<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Spinner v-if="isLoading"/>
        <div v-if="!isLoading && userData" :class="{'datatable-is-loading':employeeIsLoading}">
          <Toolbar class="p-mb-4">
            <template #start>
              <div style="font-size: 1.4em; color: inherit">{{ $t('Employee') }}: {{ userData.first_name }} {{ userData.last_name }}</div>
            </template>
            <template #end>
              <template v-if="canArchive">
                <template v-if="userData.employee">
                  <span class="p-d-inline-flex"
                        v-tooltip.bottom="billingActionTooltipOptions()"
                        v-if="userData.employee.status === 1">
                     <Button :disabled="disableEditButton || employeeIsLoading || billingDataEditingLocked"
                             :loading="employeeIsLoading"
                             @click="openConfirmModal"
                             :label="$t('Archive')"
                             icon="ti-archive"
                             class="p-button-secondary p-button-raised p-mr-2"/>
                  </span>

                  <span class="p-d-inline-flex"
                        v-tooltip.bottom="billingActionTooltipOptions()"
                        v-else-if="userData.employee.status === 2">
                     <Button :disabled="
                                disableEditButton ||
                                employeeIsLoading ||
                                billingResourceUsageIsLoading ||
                                billingDataEditingLocked
                              "
                             :loading="employeeIsLoading || billingResourceUsageIsLoading"
                             @click="openConfirmModal"
                             :label="$t('Return from archive')"
                             icon="ti-archive"
                             class="p-button-info p-button-raised p-mr-2"/>
                  </span>

                </template>
              </template>

              <span class="p-d-inline-flex"
                    v-if="$store.getters.isAccountantOrHigher"
                    v-tooltip.bottom="billingActionTooltipOptions()">
                <Button :disabled="disableEditButton || employeeIsLoading || billingDataEditingLocked"
                        :loading="employeeIsLoading"
                        :label="$t('Edit')"
                        icon="ti-pencil"
                        @click="editItem"
                        class="p-button-success p-button-raised"
                        :class="{ 'p-mr-2':canDelete }"/>
              </span>

            <span class="p-d-inline-flex"
                  v-if="canDelete"
                v-tooltip.bottom="billingActionTooltipOptions()">
               <Button class="p-button-raised p-button-warning"
                       icon="ti-trash"
                       :label="$t('Delete')"
                       :disabled="employeeIsLoading || deleteButtonDisabled || billingDataEditingLocked"
                       :loading="employeeIsLoading"
                       @click="confirmItemDelete"/>
            </span>
            </template>
          </Toolbar>


          <TabMenu :model="tabMenuItems" class="p-p-1"/>
          <router-view @update-items="updateItems"
                       :user="userData"
                       :employeeIsLoading="employeeIsLoading"/>

          <EmployeeModal :visible="itemModal"
                         :modalDataIsLoading="modalDataIsLoading"
                         :item="item"
                         @update-items="updateItems"
                         @close="closeItemModal"/>

        </div>
        <div v-else-if="!isLoading && !employeeIsLoading && !userData" class="empty-page">{{ $t('No data available') }}</div>
      </div>

      <ConfirmModal :visible="confirmModal"
                    :modalDataIsLoading="modalDataIsLoading"
                    @confirm="confirmEmployeeAction"
                    @close="closeConfirmModal"/>

      <Modal :visible="billingExtraChargeModal"
             :style="{ width: '550px', maxWidth: '95%' }"
             class="p-fluid"
             @close="closeBillingExtraChargeModal">
        <template #header>
          <div class="p-dialog-title">
            {{ $t('billing.extraResources.restoreEmployeeTitle') }}
          </div>
        </template>

        <div v-if="employeeResourceUsage" class="p-pt-2 p-pb-3">
          <InlineNotice severity="warning"
                        icon="pi pi-info-circle"
                        :title="$t('billing.extraResources.additionalEmployeeTitle')">
              {{ $t('billing.extraResources.restoreEmployeeNotice', {
              included: employeeResourceUsage.included_next,
              used: employeeResourceUsage.used,
              price: employeeResourceUsage.monthly_delta
            }) }}
            <template #actions>
              <div class="p-d-flex p-ai-center">
                <Checkbox id="restore-employee-extra-charge-confirmation"
                          v-model="billingExtraChargeConfirmed"
                          :binary="true"/>
                <label for="restore-employee-extra-charge-confirmation" class="pointer p-ml-2">
                  {{ $t('billing.extraResources.restoreEmployeeConfirmation', {
                    price: employeeResourceUsage.monthly_delta
                  }) }}
                </label>
              </div>
            </template>
          </InlineNotice>
        </div>

        <template #footer>
          <Button :label="$t('Cancel')"
                  icon="pi pi-times"
                  class="p-button-text"
                  @click="closeBillingExtraChargeModal"/>
          <Button :label="$t('Return from archive')"
                  icon="pi pi-check"
                  class="p-button-text"
                  :disabled="!billingExtraChargeConfirmed || modalDataIsLoading || billingDataEditingLocked"
                  :loading="modalDataIsLoading"
                  @click="confirmEmployeeAction"/>
        </template>
      </Modal>

      <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                          :modalDataIsLoading="modalDataIsLoading"
                          @close="closeConfirmItemDeleteModal"
                          @delete-item="deleteItem"
                          :data="itemToDeleteData"/>
    </div>
  </div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import constants from '@/constants'
import formatMixins from '@/mixins/formatMixins'
import httpMixins from "@/mixins/httpMixins";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import datatableMixins from "@/mixins/datatableMixins";
import EmployeeModal from "@/pages/employees/components/EmployeeModal.vue";
import labelMixin from "@/mixins/labelMixin";
import InlineNotice from '@/components/InlineNotice.vue'
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  mixins: [ formatMixins, httpMixins, showErrorsMixins, datatableMixins, labelMixin, billingFeaturesMixins, billingRestrictionsMixin ],
  components: { EmployeeModal, InlineNotice },
  data() {
    return {
      routePath: '/employees',
      disableEditButton: false,
      confirmModal: false,
      employeeIsLoading: false,
      itemModal: false,
      item: null,
      userId: null,
      isLoading: true,
      userData: null,
      settings,
      tabMenuItems: [],
      billingResourceUsage: null,
      billingResourceUsageIsLoading: false,
      billingExtraChargeModal: false,
      billingExtraChargeConfirmed: false,
    }
  },
  watch: {
    '$i18n.locale'() {
      if (this.userData) {
        this.generateTabMenu()
      }
    },
    canUseTechnicianEarnings() {
      if (this.userData) {
        this.generateTabMenu()
      }
    },
    billingEntitlementsReady() {
      if (this.userData) {
        this.generateTabMenu()
      }
    },
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.confirmModal) {
          this.closeConfirmModal()
        }
        if (this.itemModal) {
          this.closeItemModal()
        }
        if (this.billingExtraChargeModal) {
          this.closeBillingExtraChargeModal(false)
        }
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.getPageData()
  },
  methods: {
    getPageData() {
      this.getUserData()
    },
    async confirmEmployeeAction() {
      if (this.billingActionIsRestricted()) return

      const employeeId = this.userData?.employee?.id
      if (!employeeId || !this.$store.getters.userCanGetData) return
      this.modalDataIsLoading = true
      const obj = {
        id: employeeId,
      }

      if (this.isRestoringEmployee && this.employeeExtraChargeRequired) {
        obj.billing_confirmation = {
          confirmed: this.billingExtraChargeConfirmed,
          type: 'extra_employee',
          monthly_delta: this.employeeResourceUsage.monthly_delta,
          currency: this.billingResourceUsage.currency,
        }
      }
      try {
        const { status, data } = await httpClient.post(`employee/change-status`, obj)
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
          this.closeConfirmModal()
          this.closeBillingExtraChargeModal()
          this.getUserData()
        } else if (data?.error) {
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
        }
      } catch(err) {
        if (!this.handleExtraChargeConfirmationError(err)) {
          this.showError(err)
        }
      } finally {
        this.modalDataIsLoading = false
      }
    },
    async deleteItem() {
      if (this.billingActionIsRestricted()) return

      const employeeId = this.userData?.employee?.id
      if (!employeeId || !this.$store.getters.userCanGetData) return
      this.modalDataIsLoading = true
      this.dataTableIsLoading = true
      try {
        const { status, data } = await httpClient.post('employee/delete', { id: employeeId })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: settings.toastLife});
          this.closeConfirmItemDeleteModal()
          this.userData = null
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.modalDataIsLoading = false
        this.dataTableIsLoading = false
      }
    },
    applyBillingResourceUsage(data) {
      this.billingResourceUsage = data?.success ? data : null
      this.billingExtraChargeConfirmed = false
    },
    async loadBillingResourceUsage() {
      if (this.billingResourceUsageIsLoading) return false

      this.billingResourceUsageIsLoading = true

      try {
        const { status, data } = await httpClient.post('billing/resource-usage')

        if (status === 200 && data?.success) {
          this.applyBillingResourceUsage(data)
          return true
        }

        this.showUnknownError()
      } catch (err) {
        this.showError(err)
      } finally {
        this.billingResourceUsageIsLoading = false
      }

      return false
    },
    handleExtraChargeConfirmationError(err) {
      const response = err?.response

      if (
          response?.status !== 409
          || response?.data?.code !== 'EXTRA_CHARGE_CONFIRMATION_REQUIRED'
      ) {
        return false
      }

      this.applyBillingResourceUsage(response.data.resource_usage)
      this.confirmModal = false
      this.billingExtraChargeModal = true

      this.$toast.add({
        severity: 'warn',
        detail: this.$t('billing.extraResources.confirmationRequired'),
        life: settings.toastLife,
      })

      return true
    },
    async openConfirmModal() {
      if (this.billingActionIsRestricted()) return

      if (this.isRestoringEmployee) {
        await this.loadBillingResourceUsage()

        if (this.employeeExtraChargeRequired) {
          this.billingExtraChargeModal = true
          this.$store.commit('toggleFirstLayer', true)
          return
        }
      }

      this.confirmModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    closeConfirmModal() {
      this.confirmModal = false
      this.$store.commit('toggleFirstLayer', false)
    },
    closeBillingExtraChargeModal(closeLayer = true) {
      this.billingExtraChargeModal = false
      this.billingExtraChargeConfirmed = false

      if (closeLayer && this.$store.state.firstLayerIsOpened) {
        this.$store.commit('toggleFirstLayer', false)
      }
    },
    editItem() {
      if (this.billingActionIsRestricted()) return

      if (this.userData) {
        this.item = this.userData
        this.itemModal = true
        this.$store.commit('toggleFirstLayer', true)
      }
    },
    updateItems() {
      this.getUserData(false)
    },
    closeItemModal() {
      this.itemModal = false
      if (this.$store.state.firstLayerIsOpened === true ) {
        this.$store.commit('toggleFirstLayer', false)
      }
      this.item = null
      this.submitted = false
    },
    generateTabMenu() {
      const uid = this.$route.params.uid

      this.tabMenuItems = [
        {label: this.$t('General information'), icon: 'ti-info-alt', to: `/employees/${uid}/overview`},
        {
          label: `${this.$t('Accounts')} (${this.userData?.accountsCount ?? 0})`,
          icon: 'ti-key',
          to: `/employees/${uid}/accounts`
        },
        {
          label: `${this.$t('rolesAndPermissions')} (${this.userData?.accessCount ?? 0})`,
          icon: 'ti-shield',
          to: `/employees/${uid}/roles`
        },
        {
          label: this.$t('Earnings'),
          icon: !this.billingEntitlementsReady || this.canUseTechnicianEarnings ? 'ti-wallet' : 'ti-lock',
          to: `/employees/${uid}/earnings`
        },
      ]

      if (this.userData?.has_employee_salary_role) {
        this.tabMenuItems.push({
          label: this.$t('Salary settings'),
          icon: !this.billingEntitlementsReady || this.canUseTechnicianEarnings ? 'ti-settings' : 'ti-lock',
          to: `/employees/${uid}/salary-settings`
        })
      }
    },
    async getUserData(showSpinner = true) {
      if (!this.$route.params.uid) return
      if (!this.userCanGetData || this.employeeIsLoading) return
      this.isLoading = showSpinner
      this.disableEditButton = true
      this.employeeIsLoading = true
      const ctrl = this.setController?.('employeeData')
      try {
        const { status, data } = await httpClient({
          url: 'user/get-by-uid',
          method: 'post',
          params: {
            expand: 'creator,' +
                'tax,' +
                'employee,' +
                'employee.creator,' +
                'address,' +
                'has_employee_salary_role,' +
                'accountsCount,' +
                'accessCount,' +
                'access_map,' +
                'archived_access_map,' +
                'max_role_with_archived',
          },
          data: { uid: this.$route.params.uid },
          signal: ctrl?.signal
        })
        if (status === 200 && data && data.success && data.item) {
          this.userData = data.item
          this.generateTabMenu()
        } else {
          this.showUnknownError()
          this.userData = null
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.employeeIsLoading = false
        this.isLoading = false
        this.disableEditButton = false
        if (this._abortors?.employeeData === ctrl) {
          this._abortors.employeeData = null
        }
      }
    },
  },
  computed: {
    isRestoringEmployee() {
      return Number(this.userData?.employee?.status) === 2
    },
    employeeResourceUsage() {
      return this.billingResourceUsage?.resources?.employee ?? null
    },
    employeeExtraChargeRequired() {
      return !!this.employeeResourceUsage?.requires_confirmation
    },
    // cannotChangeEmployeeStatus() {
    //   if (!this.userData?.employee?.id) return true
    //
    //   const targetRole = Number(this.userData?.max_role_with_archived || 0)
    //   const currentRole = Number(this.$store.getters.effectiveRole || 0)
    //   const roles = constants.userRoles
    //
    //   if (!currentRole) return true
    //
    //   if (currentRole === roles.superAdmin) {
    //     return false
    //   }
    //
    //   if (currentRole === roles.owner) {
    //     return targetRole === roles.superAdmin
    //   }
    //
    //   if (currentRole === roles.admin) {
    //     if (!targetRole) return false
    //
    //     return ![
    //       roles.moderator,
    //       roles.employeeWorkshopMaster,
    //       roles.employeeMaster,
    //     ].includes(targetRole)
    //   }
    //
    //   return true
    // },
    cannotChangeEmployeeStatus() {
      if (!this.userData?.employee?.id) return true

      const targetRole = Number(this.userData?.max_role_with_archived || 0)
      const currentRole = Number(this.$store.getters.effectiveRole || 0)
      const roles = constants.userRoles

      if (!currentRole) return true

      if (currentRole === roles.superAdmin) {
        return false
      }

      if (currentRole === roles.owner) {
        return targetRole === roles.superAdmin
      }

      // ADMIN и ACCOUNTANT могут управлять
      // moderator / workshop master / employee
      if (this.$store.getters.isAccountantOrHigher) {
        if (!targetRole) return false

        return ![
          roles.moderator,
          roles.employeeWorkshopMaster,
          roles.employeeMaster,
        ].includes(targetRole)
      }

      return true
    },
    itemToDeleteData() {
      if (!this.userData) return null
      return this.getCustomerLabel(this.userData)
    },
    canArchive() {
      return this.$store.getters.isAccountantOrHigher && !this.cannotChangeEmployeeStatus
    },
    // canDelete() {
    //   return this.$store.getters.isAccountantOrHigher &&
    //       !this.cannotChangeEmployeeStatus
    // },

    canDelete() {
      const currentRole = Number(this.$store.getters.effectiveRole || 0)
      const roles = constants.userRoles

      return (
          currentRole === roles.admin ||
          this.$store.getters.isOwnerOrHigher
      ) && !this.cannotChangeEmployeeStatus
    },

    // deleteButtonDisabled() {
    //   if (!this.userData) return true
    //
    //   const targetId = Number(this.userData.id || 0)
    //   const currentId = Number(this.$store.getters.userData?.id || 0)
    //
    //   return targetId === currentId ||
    //       !this.$store.getters.isAccountantOrHigher ||
    //       this.cannotChangeEmployeeStatus
    // }
    deleteButtonDisabled() {
      if (!this.userData) return true

      const targetId = Number(this.userData.id || 0)
      const currentId = Number(this.$store.getters.userData?.id || 0)

      return targetId === currentId || !this.canDelete
    },
  }
}
</script>

<style scoped lang="scss">
.datatable-wrapper {
  overflow-y: auto;
  padding-bottom: 25px;
}

.positions-table {
  border-collapse: collapse;
  width: 100%;
  tr {
    td {
      padding: 8px !important;
    }
  }
}

</style>
